import React from 'react';
import { Box, Typography, Container, Grid, Link, Stack, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PublicIcon from '@mui/icons-material/Public'; 

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#fff',
        color: 'text.secondary',
        py: 3,
        borderTop: '1px solid #eaeaea',
        mt: 'auto',
        width: '100%',
      }}
    >
      <Container maxWidth="lg">

{/* Quick links */}
        <Grid container justifyContent="center" spacing={3} sx={{ mb: 2 }}>
          <Grid item>
            <Link component={RouterLink} to="/" color="inherit" underline="hover">
              Home
            </Link>
          </Grid>
          <Grid item>
            <Link component={RouterLink} to="/monitoring" color="inherit" underline="hover">
              Monitor Map
            </Link>
          </Grid>
          <Grid item>
            <Link component={RouterLink} to="/analysis" color="inherit" underline="hover">
              Analysis
            </Link>
          </Grid>
        </Grid>

        {/* Social icons */}
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 2 }}>
          <Link href="https://www.aques.org/" target="_blank" rel="noopener" color="inherit" underline="none" sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton aria-label="Website" size="small" color="inherit">
              <PublicIcon fontSize="small" />
            </IconButton>
            <Typography variant="body2" sx={{ ml: 0.5 }}>AquES</Typography>
          </Link>
          <Link href="https://www.linkedin.com/in/moritz-m%C3%BCller-1b105723/" target="_blank" rel="noopener" color="inherit" underline="none" sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton aria-label="LinkedIn" size="small" color="inherit">
              <LinkedInIcon fontSize="small" />
            </IconButton>
            <Typography variant="body2" sx={{ ml: 0.5 }}>Professor Dr Moritz Müller</Typography>
          </Link>
        </Stack>

        {/* Copyright */}
        <Typography variant="body2" align="center">
          © {year} ENVIMON. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;